import React, { ChangeEvent, useEffect }  from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import {
  Typography,
  TextField,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core';
import AutocompleteSelect from './common/AutocompleteSelect';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200
    },
    dense: {
      marginTop: theme.spacing(2),
    },
    menu: {
      width: 200,
    }
  }),
);

export interface TopFormSearchOption {
  readonly label: string;
  readonly value: string;
}

interface TopFormSearchProps {
  readonly onSearchInputChange: (searchInput: string) => void;
  readonly onSearchTypeChange: (searchType: TopFormSearchOption) => void;
  readonly searchInput: string;
  readonly searchOptions: TopFormSearchOption[];
  readonly marginTop? : number
  readonly numericOnlyFields? : string[]
  readonly numericRangeFields?: string[];
  readonly statusOptions?: TopFormSearchOption[];
  readonly statusValue?: string[];
  readonly onStatusChange?: (statusValues: string[]) => void;
};

export default function TopFormSearch(props: TopFormSearchProps) {
  const classes = useStyles();

  const [ searchType, setSearchType ] = React.useState<TopFormSearchOption>(props.searchOptions[0]);
  const isNumericOnlyField = props.numericOnlyFields?.includes(searchType.value) || false;
  const isNumericRangeField = props.numericRangeFields?.includes(searchType.value) || false;

  const handleStatusChange = (value: any | any[] | null): void => {
    props.onStatusChange?.(Array.isArray(value) ? value : []);
  };

  const handleSearchInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;
    const isNumericOnlyField = props.numericOnlyFields?.includes(searchType.value) || false;
    const isNumericRangeField = props.numericRangeFields?.includes(searchType.value) || false;
    if (isNumericOnlyField) {
      if (/^\d*$/.test(value)) {
        props.onSearchInputChange(value);
      }
    } else if (isNumericRangeField) {
      if (/^\d*\.?\d*(?:-\d*\.?\d*)?$/.test(value)) {
        props.onSearchInputChange(value);
      }
    }else {
      props.onSearchInputChange(value);
    }
  };

  const handleSearchTypeChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchType = props.searchOptions.find(
      so => so.value === event.target.value
    )!;

    setSearchType(searchType);
    props.onSearchTypeChange(searchType);
  };
  const searchOptions: JSX.Element[] = props.searchOptions.map(so =>
    <FormControlLabel
      control={<Radio color="primary" />}
      key={so.value}
      label={so.label}
      value={so.value}
      style={{ marginRight: 8 }}
    />
  );

  return (
      <Grid container spacing={2} alignItems="flex-start" justifyContent="space-around">
        {props.statusOptions && props.statusOptions.length > 0 && (
          <Grid item xs={5} style={{ paddingTop: 47 }}>
            <AutocompleteSelect
              options={props.statusOptions}
              value={props.statusValue || []}
              onChange={handleStatusChange}
              label="Status"
              placeholder="Select Status"
              showBreaks={false}
              flags={{
                enableAutocomplete: true,
                enableMultiSelect: true,
                sortOptions: true,
              }}
            />
          </Grid>
      )}
        <Grid
          item
          xs={props.statusOptions && props.statusOptions?.length > 0 ? 6 : 12}
          className="contracts-search"
        >
        <Typography variant="h3" align={'left'}>
          <TextField
            className={classes.textField}
            onChange={handleSearchInputChange}
            placeholder={isNumericRangeField ? 'Amount or range (e.g. 10-20)' : isNumericOnlyField ? 'Enter numbers only' : 'Search'}
            style={{ marginTop: props.marginTop == null || props.marginTop == undefined ? 60 : props.marginTop, width: '100%' }}
            value={props.searchInput}
            inputProps={{
              pattern: isNumericRangeField ? '[0-9]*\\.?[0-9]*(-[0-9]*\\.?[0-9]*)?' : isNumericOnlyField ? '[0-9]*' : undefined,
              inputMode: isNumericRangeField ? 'text' : isNumericOnlyField ? 'numeric' : 'text'
            }}
          />
        </Typography>
        <Grid xs={12} className="radios">
          <RadioGroup
            aria-label="top-form"
            row
            name="top-form"
            onChange={handleSearchTypeChange}
            value={searchType.value}
          >
            {searchOptions}
          </RadioGroup>
        </Grid>
      </Grid>
    </Grid>
  );
}